import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=4e145cfa"
import script from "./Wysiwyg.vue?vue&type=script&lang=js"
export * from "./Wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./Wysiwyg.vue?vue&type=style&index=0&id=4e145cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports